export default __webpack_public_path__ + "static/image2-b111528ca26c2f0586f095af8cf257c8.jpg";